/** Staff single sign-on (M29 P2, SEC-008): mirror of backend `app/core/constants/staff_sso.py`.
 *  `backend/tests/core/test_staff_sso_mirror.py` keeps the two equal. */

export const SSO_KINDS = ["saml", "oidc"] as const;
export type StaffSsoKind = (typeof SSO_KINDS)[number];

export const SSO_DOMAINS_MAX = 20 as const;
export const SSO_METADATA_MAX_BYTES = 262144 as const;

/** Mail domains anybody can use: never claimed by one workspace. */
export const SSO_PUBLIC_MAIL_DOMAINS = [
  "aol.com",
  "gmail.com",
  "gmx.com",
  "googlemail.com",
  "hotmail.com",
  "icloud.com",
  "live.com",
  "mail.com",
  "me.com",
  "msn.com",
  "outlook.com",
  "proton.me",
  "protonmail.com",
  "yahoo.com",
  "yandex.com",
  "ymail.com",
  "zoho.com",
] as const;

/** Query keys the API puts on the redirect that ends a single sign-on attempt. */
export const SSO_ERROR_QUERY = "sso_error" as const;
export const SSO_TEST_QUERY = "sso_test" as const;
